const lbaSwitch = angular.module('app.lbaSwitch', []);

lbaSwitch.controller('lbaSwitchCtrl', require('./lbaSwitchCtrl'));
lbaSwitch.directive('lbaSwitch', require('./lbaSwitchDir'));

export default lbaSwitch;



// WEBPACK FOOTER //
// ./src/components/lbaSwitch/index.js